import {isLinkableWhiteboardObject} from "./whiteboardLinks";

/**
 * Détermine l'étape suivante d'une liaison sans toucher au canevas ni à React.
 * La sélection Fabric reste ainsi un événement unique et prévisible : aucune
 * ré-entrée dans le cycle de pointeur / sélection n'est nécessaire.
 */
export const getConnectorSelectionStep = ({style, source, target}) => {
    if (!style || !isLinkableWhiteboardObject(target)) {
        return {type: "ignore"};
    }

    if (!source) {
        return {type: "source", source: target};
    }

    if (source === target) {
        return {type: "same-object"};
    }

    return {type: "complete", source, target, style};
};
